<template>
	<div class="contact-list" :style="{ height: height + 'px' }">
		<el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick($event)">
			<span class="contact-tree-node" slot-scope="{ data }">
				<span v-if="data.users"> {{ data.customer_id | removeFrontZero }} {{ data.customer_name }} </span>
				<span v-if="!data.users" :class="{ disabled: data.disabled }">
					<span class="avatar">
						<ChatAvatar :avatar="data.avatar" size="14" borderRadius="50%" />
					</span>
					<span class="nick-name">
						{{ data.nick_name }}
						<span v-if="data.note && data.note.note" :title="$t('contactList.remarkName') + data.note.note"> ({{ data.note.note }}) </span>
					</span>
				</span>
			</span>
		</el-tree>
	</div>
</template>

<script>
import ChatAvatar from "./chat-avatar.vue";

export default {
	components: {
		ChatAvatar,
	},

	name: "ContactList",

	props: {
		data: {
			type: Array,
			required: true,
		},
		height: {
			type: Number,
			required: false,
			default: null,
		},
	},

	data() {
		return {
			defaultProps: {
				children: "users",
				label: "nick_name",
			},
		};
	},

	methods: {
		handleNodeClick(event) {
			this.$emit("node-click", event);
		},
	},
};
</script>

<style lang="less" scoped>
.contact-list {
	overflow-y: auto;
}

.contact-list::-webkit-scrollbar-thumb {
	border-radius: 1em;
	background-color: rgba(50, 50, 50, 0.3);
}

.contact-list::-webkit-scrollbar-track {
	border-radius: 1em;
	background-color: rgba(50, 50, 50, 0.1);
}

.contact-tree-node {
	font-size: 12px;

	img {
		margin-right: 5px;
	}
}
.disabled {
	display: flex;
	.avatar {
		position: relative;
		box-sizing: border-box;
		border: 1px solid #f88282;
		border-radius: 50%;
		width: 14px;
		height: 14px;
		overflow: hidden;
		text-overflow: ellipsis;
		margin-right: 5px;
	}
	.avatar::before {
		content: "";
		width: 100%;
		height: 1px;
		background-color: #f88282;
		position: absolute;
		top: 6px;
		transform: rotate(45deg);
	}
	.nick-name {
		text-decoration: line-through;
	}
}
</style>

<style lang="less">
.el-tree__empty-text {
	font-size: 14px;
	color: #909399;
}
</style>
